<template>
  <main class="app-container">
    <page-content page_key="become-leader"></page-content>

    <md-landscape v-model="showFullScreen" full-screen>
      <become-leader-form @onFormClose="showFullScreen = false"></become-leader-form>
    </md-landscape>

    <div class="action-bar-placeholder"></div>
    <md-action-bar :actions="data"></md-action-bar>

  </main>
</template>

<script>
import { ActionBar, Landscape } from 'mand-mobile'

import PageContent from "../components/PageContent.vue";
import BecomeLeaderForm from "../components/BecomeLeaderForm.vue";

export default {
  name: "BecomeLeader",
  components: {
      PageContent,
      BecomeLeaderForm,
      [ActionBar.name]: ActionBar,
      [Landscape.name]: Landscape,
  },
  data() {
      return {
          showFullScreen:false,
          data: [
              {
                  text: '申请成为Leader',
                  onClick: this.handleClick,
              },
          ],
      }
  },
  methods: {
      handleClick() {
          this.showFullScreen = true;
      },
  },
};
</script>


<style lang="scss" scoped>
.action-bar-placeholder {
  height:150px
}


</style>
